// export const apiUrl = 'http://api.textile.osvin.net/api/'
// export const imagerUrl = 'http://api.textile.osvin.net'
// export const apiUrl = 'http://192.168.1.55:3005/api/'
// export const imagerUrl = 'http://192.168.1.55:3005'
export const apiUrl = 'https://www.api.shreeshyams.com/api/'
export const imagerUrl = 'https://www.api.shreeshyams.com'